module.exports = __webpack_public_path__ + "static/media/ribbon.75d078b1.svg";